/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { isEmpty, find, get } from 'lodash-es';

// Services
import { DataSetService } from '@portal/app/dashboard/home-page/services/data-set.service';

// Types
import { FieldDefinitions, Filter } from '@portal/app/shared/types';
import {
  IMmmModalResponse,
  MmmBannerService
} from '@portal/app/shared/components/mmm-banner/mmm-banner.service';
import { ViewStore } from '@portal/app/shared/state/view.store';
import { take } from 'rxjs';
import { Router } from '@angular/router';
import { SelectionService } from '@portal/app/shared/services/selection.service';

@Component({
  selector: 'portal-mmm-banner',
  templateUrl: './mmm-banner.component.html',
  styleUrls: ['./mmm-banner.component.scss'],
  standalone: false
})
export class MmmBannerComponent implements OnInit, OnChanges {
  conversionType = '';
  startDate = '';
  endDate = '';
  spend = 0;
  noOfContributingTactics = 0;
  mimModelVersion = 1;

  @Input() mmmTooltip = '';
  @Input() filters: Filter[] = [];
  @Input() brandId = 0;
  @Input() fieldDefinitions: FieldDefinitions = {};
  literalId = '';

  constructor(
    private readonly dataSetService: DataSetService,
    private readonly mmmBannerService: MmmBannerService,
    private readonly viewStore: ViewStore,
    private readonly router: Router,
    private readonly selectionService: SelectionService
  ) {}

  ngOnInit() {
    this.viewStore.selectedBCPDId.pipe(take(1)).subscribe((value) => {
      this.literalId = value.literalId;
    });
    this.fetchData(this.filters);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.filters) {
      this.fetchData(changes.filters.currentValue);
    }
  }

  navigateToMmmDoc(): void {
    window.open(
      'https://support.measured.com/article/h62nuemky4-mim-overview',
      '_blank'
    );
  }

  shouldRedirectToModal() {
    return this.mimModelVersion === 2 && this.literalId === 'cross-channel';
  }

  redirectToModelDetails() {
    if (this.shouldRedirectToModal()) {
      this.router.navigate(
        [`/a/${this.selectionService.buildSelectionSlug()}/products/mim-page`],
        { queryParams: { tab: 1 } }
      );
    } else {
      this.navigateToMmmDoc();
    }
  }

  fetchData(filters: Filter[]) {
    const currentFilters = this.mmmBannerService.getFilters(
      filters,
      this.brandId
    );
    const conversionTypeValue = get(
      find(currentFilters, { literalId: 'conversion_type' }),
      'value'
    );

    this.dataSetService
      .fetchDataSets({
        dimensions: [],
        filters: currentFilters,
        dashboardLiteralId: 'home-page',
        productLiteralId: 'portfolio'
      })
      .subscribe({
        next: (response) =>
          this.processResponse(response, conversionTypeValue as string),
        error: (err) => console.error(err)
      });
  }

  private processResponse(response: any, conversionTypeValue: string) {
    if (!isEmpty(response)) {
      const formattedResponse = find(
        this.mmmBannerService.formatData(response, this.fieldDefinitions),
        { conversionType: conversionTypeValue }
      ) as IMmmModalResponse;

      if (formattedResponse) {
        const {
          conversionType,
          startDate,
          endDate,
          spend,
          noOfContributingTactics,
          mimModelVersion
        } = formattedResponse;
        Object.assign(this, {
          conversionType,
          startDate,
          endDate,
          spend,
          noOfContributingTactics,
          mimModelVersion: parseInt(mimModelVersion.toString(), 10)
        });
        this.updateTooltip();
      }
    }
  }

  updateTooltip() {
    this.mmmTooltip = this.mmmBannerService.generateTooltip(
      this.conversionType,
      this.startDate,
      this.endDate,
      this.spend,
      this.noOfContributingTactics,
      this.mimModelVersion
    );
  }
}
